<template>
  <div id="user-manage-employees">
    <div class="ipub-h1 relative line-h-40 mar-b-20">
      Manage Employees
      <div class="right-option ipub-p1">
        <ipub-button v-if="
          user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_EMPLOYEES.ADD')"
                     icon="iconAdd"
                     type="primary"
                     @click="add">
          Add New
        </ipub-button>
        <!-- <ipub-button type="primary"
                       plain>
            Delete
          </ipub-button> -->
        <ipub-button type="primary"
                     v-if="
          user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_EMPLOYEES.EXPORT')"
                     @click="exp"
                     plain>
          Export
        </ipub-button>
      </div>
    </div>
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="2">
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         @change="changeJournal"
                         :options="journalList" />
          </ipub-col>
          <ipub-col :span="10">
            <site-search-group v-model.trim="params.keyword"
                               placeholder="Search by employees’ name, email"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showAdv">
          <ipub-row :gutter="16">
            <ipub-col :span="8"
                      class="flex">
              <span class="ipub-p2 fw-bd line-h-40">Roles</span>
              <ipub-select class="mar-l-20"
                           style="width:400px"
                           search
                           mode="multiple"
                           @blur="getRoles('')"
                           @search="getRoles"
                           v-model="roleIdListArr"
                           placeholder="Select Role"
                           @change="getList()"
                           :options="roles">
                <ipub-select-option v-for="value in roles"
                                    :key="value.id"
                                    :value="value">
                  {{value.journal&&value.journal.name}} {{value.name}}
                </ipub-select-option>
              </ipub-select>
            </ipub-col>
          </ipub-row>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>
    <div class="page-content">

      <div class="page-content-table">
        <ipub-table :columns="columns"
                    fixed
                    :empty="{icon:'iconuser'}"
                    emptyText="There is no employee."
                    :pagination="pagination"
                    :dataSource="dataSource">
          <template v-slot:email="{ record }">
            <ipub-tooltip>
              <div slot="title">{{record.email}}</div>
              <span class="ipub-c-p link-color"
                    @click="detail(record)">{{record.email}}</span>
            </ipub-tooltip>
          </template>
          <template v-slot:name="{ record }">
            <ipub-tooltip style="width:100%"
                          placement="bottomLeft"
                          omis="omis"
                          :label="`${record.firstName||'-'} ${record.lastName||'-'}`" />
          </template>
          <template v-slot:roles="{ text }">
            <ipub-tooltip v-if="text&&text.length"
                          style="width:100%"
                          placement="bottomLeft"
                          omis="omis"
                          :label="`${text.map((item)=>{return `${item.journal&&item.journal.name||''} ${item.name}`}).join(', ')}`" />
            <template v-else>- -</template>
          </template>
          <template v-slot:status="{text}">
            <template v-if="text">
              <ipub-label cover
                          type="success"
                          size="small">Abled</ipub-label>
            </template>
            <template v-else>
              <ipub-label cover
                          type="danger"
                          size="small">Disabled</ipub-label>
            </template>
          </template>
          <template v-slot:actions="{ record }">
            <ipub-tooltip class="border-right"
                          v-show="user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_EMPLOYEES.DETAILS')">
              <div slot="title">Details</div>
              <ipub-icon type="iconViewDetails"
                         @click="detail(record)" />
            </ipub-tooltip>
            <ipub-tooltip class="border-right"
                          v-show="user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_EMPLOYEES.EDIT')">
              <div slot="title">Edit</div>
              <ipub-icon type="iconEdit"
                         @click="edit(record)" />
            </ipub-tooltip>
            <template v-if="user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_EMPLOYEES.DISABLE')">
              <ipub-tooltip v-if="record.enabled"
                            class="border-right">
                <div slot="title">Disable</div>
                <ipub-icon type="iconDisable"
                           @click="able(record)" />
              </ipub-tooltip>
              <ipub-tooltip v-else
                            class="border-right">
                <div slot="title">Able</div>
                <ipub-icon type="iconAble"
                           @click="able(record)" />
              </ipub-tooltip>
            </template>
            <ipub-tooltip v-show="user.codeList&&user.codeList.includes('USER_MANAGE.MANAGE_EMPLOYEES.DELETE')">
              <div slot="title">Delete</div>
              <ipub-icon type="iconDelete"
                         @click="del(record)" />
            </ipub-tooltip>
          </template>
        </ipub-table>
      </div>
    </div>
    <Add :isVisable="isVisable"
         :inputData="inputData"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
